import React, { ChangeEvent, FC, useEffect, useRef, useState } from "react";
import {
    createOptionListForSelectTag,
    isNullOrEmpty, postalPattern, postalTitle
} from "../../../../helpers/utils/Utils";
import { useGetAllStatesQuery } from "../../../data/states/statesApi";
import {
    useGetAllCountyByStateAbbrQuery,
} from "../../../data/counties/countiesApi";
import { CreateOrderTabProps } from "../OrderDetailsTab";
import SelectField from "../../../../components/common/form/SelectField";
import InputField from "../../../../components/common/form/InputField";
import { useGetEnumsQuery } from "../../../../app/globalApi";
import { PropertyInfoForm } from "./PropertyInfoForm";
import { skipToken } from "@reduxjs/toolkit/query";
import Button from "../../../../components/common/form/Button";
import { OptionType } from "../../../../helpers/utils/StyleUtils";
import TextAreaField from "../../../../components/common/form/TextAreaField";
import { IoIosArrowForward } from "react-icons/io";
import ModalButton from "../../../../components/common/form/ModalButton";
import { FaTrash } from "react-icons/fa";
import ConfirmationModal from "../../../../components/layout/modal/ConfirmationModal";
import { FaHouseSignal } from "react-icons/fa6";
import IconButton from "../../../../components/common/form/IconButton";
import { OrderPropertyPickerModal } from "../../modal/OrderPropertyPickerModal";
import Form from "../../../../components/common/form/Form";

const PropertyDetailTab: FC<CreateOrderTabProps> = ({ createOrderData, setCreateOrderData, setTab }) => {
    const statesApiResult = useGetAllStatesQuery("");
    const statesOptions = createOptionListForSelectTag(statesApiResult?.data, "stateName", "stateAbbreviation");
    const [property, setProperty] = useState<any>({ state: { label: "Texas", value: "TX" } });
    const [propertiesList, setPropertiesList] = useState<any[]>([]);

    const { data: enums } = useGetEnumsQuery("");

    const countiesApiResult = useGetAllCountyByStateAbbrQuery(
        property?.state ? property.state.value : skipToken
    );
    const [showPackageDetail, setShowPackageDetail] = useState<boolean[]>(new Array(property.length).fill(createOrderData?.properties?.length <= 0 ? false : true));
    const [toggle, setToggle] = useState(createOrderData?.properties?.length <= 0 ? false : true);
    const [showPropertyPickerModal, setShowPropertyPickerModal] = useState(false);
    const [isInitialStateSet, setIsInitialStateSet] = useState(false);

    const handleOnChange = (
        e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLTextAreaElement> | { name: string; value: OptionType | null }
    ) => {
        const { name, value } = "target" in e ? e.target : e;

        const updatedProperties = {
            ...property,
            [name]: value
        };

        // If state is cleared, also clear countyName
        if (name === "state" && value === null) {
            updatedProperties.countyName = null;
        }

        setProperty(updatedProperties);
    };

    const isNextButtonEnabled = () => {
        return ["orderNumber", "customerId", "branchId", "products"]?.every(cur => !isNullOrEmpty(createOrderData?.[cur]))
    }

    const handleAddProperty = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (Object.keys(property).length === 0) return;

        const newProperty = {
            sequence: propertiesList.length + 1,
            address: {
                streetAddress: property?.address || "",
                city: property?.city || "",
                state: property?.state,
                zip: property?.zipcode || "",
            },
            accountNumber: property?.taxNo || null,
            countyName: property?.countyName,
            legalDescription: property?.legalDescription || "",
            propertyRequestSource: "CUSTOMER",
            propertyType: property?.propertyType,
        };

        setPropertiesList((prevList) => [...prevList, newProperty]);

        setCreateOrderData((prev: any) => ({
            ...prev,
            properties: [...(prev?.properties || []), newProperty] // ✅ Append as one object
        }));

        setProperty({ state: { label: "Texas", value: "TX" } }); // Reset the form
        setToggle(true);
    };


    const handleSave = (index: number, e: any) => {
        // Create a new array with the updated item


        const updatedList = [...propertiesList]
        updatedList[index] = e

        setCreateOrderData((prev: any) => ({
            ...prev,
            properties: updatedList,
        }));

        setPropertiesList(updatedList);
    }

    const toggleShowPackageDetail = (index: number) => {
        const updatedShowPackageDetail = [...showPackageDetail];
        updatedShowPackageDetail[index] = isNullOrEmpty(updatedShowPackageDetail[index]) ? true : !updatedShowPackageDetail[index];
        setShowPackageDetail(updatedShowPackageDetail);
    }

    const handlePropertyDelete = (index: number) => {
        const updatedProperties = [...createOrderData.properties];
        const [removedProperty] = updatedProperties.splice(index, 1);

        setCreateOrderData((prev: any) => ({
            ...prev,
            properties: updatedProperties,
        }));

        setPropertiesList([removedProperty]); // Or append if needed
    };

    const handleUndo = (index: number) => {
        toggleShowPackageDetail(index);
    };
    useEffect(() => {
        if (!isInitialStateSet && statesOptions.length > 0) {
            const texasOption = statesOptions.find(option => option.value === 'TX');
            if (texasOption) {
                setProperty((prev: any) => ({ ...prev, state: texasOption }));
                setIsInitialStateSet(true);
            }
        }
    }, [statesOptions, isInitialStateSet]);

    useEffect(() => {
        setPropertiesList(createOrderData?.properties)
    }, [createOrderData]);

    return (
        <>
            {!toggle &&
                <Form onSubmit={handleAddProperty} fields={<>
                    <div className="border border-surface-5 p-5 mt-3">

                        <SelectField
                            label="Property Type"
                            value={property?.propertyType}
                            placeholder="Select Property Type..."
                            options={createOptionListForSelectTag(enums?.["PropertyType"], "value", "constant")}
                            onChange={(selectedOption: any) => handleOnChange({
                                name: 'propertyType',
                                value: selectedOption
                            })}
                        />
                        <InputField
                            label="Tax Account No."
                            value={property?.accountNumber}
                            placeholder="Enter Tax Account No..."
                            type="text"
                            name={"taxNo"}
                            onChange={handleOnChange}

                        />
                        <InputField
                            label="Address"
                            value={property?.address}
                            placeholder="Enter Address..."
                            type="text"
                            name={"address"}
                            onChange={handleOnChange}
                            required
                        />

                        <SelectField
                            placeholder='Select State...'
                            value={property?.state ?? null}
                            options={statesOptions}
                            onChange={(selectedOption: any | null) => {
                                handleOnChange({ name: "state", value: selectedOption });
                            }}
                            label="State"
                            required={true}
                        />
                        <SelectField
                            placeholder='Select County...'
                            value={property?.countyName ?? null}
                            options={createOptionListForSelectTag(countiesApiResult?.data, "countyName", "countyName")}
                            onChange={(selectedOption) => {
                                handleOnChange({ name: "countyName", value: selectedOption });
                            }}
                            label={"County"}
                            required={true}
                            isDisabled={!property?.state}
                        />
                        <InputField
                            label="City"
                            value={property?.city}
                            placeholder="Enter City..."
                            type="text"
                            name={"city"}
                            onChange={handleOnChange}
                        />
                        <InputField
                            label="Zip Code"
                            value={property?.zip}
                            placeholder="Enter Zipcode..."
                            type="text"
                            name={"zipcode"}
                            onChange={handleOnChange}
                            pattern={postalPattern} title={postalTitle}
                        />

                        <TextAreaField
                            label="Legal description"
                            value={property?.legalDescription}
                            placeholder="Enter Legal Description..."
                            name={"legalDescription"}
                            onChange={handleOnChange}
                        />

                        <div className={"flex justify-end text-end mt-4"}>
                            <Button btnText={"Add Property"} isLoading={false} type={"submit"}
                                isDisabled={!isNextButtonEnabled()}
                            />
                        </div>
                    </div>
                </>} />
            }
            <div className={"flex justify-end text-end mt-4 gap-2"}>
                <Button btnText={"Previous"} className={"bg-surface-5 !text-surface-0"} isLoading={false}
                    type={isNextButtonEnabled() ? "submit" : "button"}
                    onClick={() => {
                        setTab(1)
                    }}
                    isDisabled={!isNextButtonEnabled()}
                />

                <IconButton
                    className={'h-[35px] min-w-[52px] rounded-[11px]'}
                    icon={<FaHouseSignal size={18} className={"fa-2x"} />
                    }
                    hasBackground={true}
                    onClick={() => {
                        setShowPropertyPickerModal(true)
                    }}
                />

                <Button btnText={"Add Addt'l Property"} isLoading={false}
                    type={isNextButtonEnabled() ? "submit" : "button"}
                    onClick={() => {
                        setToggle(false)
                    }}
                    isDisabled={!isNextButtonEnabled()}
                />
                <Button btnText={"Next"} isLoading={false} type={isNextButtonEnabled() ? "submit" : "button"}
                    onClick={() => {
                        setTab(3)
                    }}
                    isDisabled={!isNextButtonEnabled()}
                />
            </div>

            {
                createOrderData?.properties?.map((curProperty: any, index: number) => (
                    <div className={`col-span-12 md:grid md:grid-cols-12 ${index === 0 ? "mt-3" : "mt-1"}`} key={index}>

                        <div className="bg-highlight-0 pt-2 col-span-12">
                            <div className="bg-highlight-0 justify-between flex px-2 py-1 cursor-pointer">
                                <div className="flex gap-1 items-center">
                                    <h3 className="text-text-0 font-semibold">{curProperty?.address?.streetAddress}</h3>
                                </div>
                                <div className="flex gap-3">
                                    <IoIosArrowForward
                                        className={"text-text-0 text-lg cursor-pointer " + (showPackageDetail[index] ? "rotate-90" : "")}
                                        onClick={() => {
                                            toggleShowPackageDetail(index);
                                        }}
                                    />

                                    <ModalButton
                                        triggerButton={<FaTrash
                                            className={`text-md hover:text-text-hover-1 ${curProperty.propertyRequestSource !== "CERT_ACCOUNT" ? "cursor-pointer text-text-0" : "text-text-2"}`}
                                            title={curProperty.propertyRequestSource !== "CERT_ACCOUNT" ? "Delete Property Info" : ""} />}
                                        onOpen={() => {
                                        }}
                                        modal={
                                            curProperty.propertyRequestSource !== "CERT_ACCOUNT" ? <ConfirmationModal
                                                show={true}
                                                setShow={() => {
                                                }}
                                                title={"Delete Property"}
                                                bodyMessage={"Are you sure you want to delete this property?"}
                                                onSubmit={() => handlePropertyDelete(index)}
                                                isLoading={false}
                                            /> : <></>
                                        }
                                    />
                                </div>
                            </div>
                            {
                                showPackageDetail[index] &&
                                <div className="col-span-9">
                                    <PropertyInfoForm
                                        enums={enums}
                                        submitBtnText="Save"
                                        handleSubmitAction={(e) => {
                                            handleSave(index, e)
                                        }}
                                        obj={curProperty}
                                        undoAction={() => {
                                            handleUndo(index)
                                        }}
                                        setUnsavedPersonInfo={setProperty}
                                    />
                                </div>
                            }
                        </div>
                    </div>
                ))}

            {
                showPropertyPickerModal &&
                <OrderPropertyPickerModal show={showPropertyPickerModal}
                    setShow={setShowPropertyPickerModal}
                    createOrderData={createOrderData}
                    setCreateOrderData={setCreateOrderData}
                    stateAbbr={"TX"}
                    countyName={""}
                />
            }
        </>


    )
}


export default PropertyDetailTab